import {FC, isValidElement, ReactNode, useEffect, useState} from 'react'

import cn from 'classnames/bind'
import AnimateHeight from 'react-animate-height'
import {FieldError} from 'react-hook-form'

import s from './MessageBlock.module.scss'
const cx = cn.bind(s)

export interface IMessageBlockProps {
	className?: string
	type: 'error' | 'success' | 'warning'
	message: string | ReactNode | Record<string, FieldError | undefined>
}

const MessageBlock: FC<IMessageBlockProps> = ({className, message, type = 'error'}) => {
	const [isMounted, setIsMounted] = useState(false)
	useEffect(() => setIsMounted(true), [])

	const getContent = () => {
		let content = message
		if (type === 'error' && typeof message === 'object' && !isValidElement(message)) {
			const errors = Object.values(message || {}) as Array<FieldError | undefined>
			if (errors.length === 0) return null

			content = (
				<ul className={cx('list')}>
					{errors.map((err) => (
						<li className={cx('list__item')} key={err?.message}>
							{err?.message}
						</li>
					))}
				</ul>
			)
		}
		return content
	}

	const hasMessage = () => {
		if (typeof message === 'object') {
			const errors = Object.values(message || {}) as Array<FieldError | undefined>
			return errors.length > 0
		}
		if (typeof message === 'string' && message.length > 0) return true
	}

	const content = getContent()

	return (
		<AnimateHeight duration={300} height={isMounted && hasMessage() ? 'auto' : 0}>
			<div className={cx('wrapper', 'fs-s', className, type)}>
				{content && <div data-testid="message-block">{content}</div>}
			</div>
		</AnimateHeight>
	)
}

MessageBlock.displayName = 'MessageBlock'

export default MessageBlock
